// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="containerh3">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Contact</h3>
            <p>S.N.SINHA COLLEGE</p>
            <p>Warisaliganj, Nawada, Bihar - 805130</p>
            <p>Email: snscwrs@gmail.com</p>
          </div>
          
          <div className="footer-links">
            <div className="links-section">
              <h4>USEFUL LINKS</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
            
            <div className="links-section">
              <h4>EXTERNAL LINKS</h4>
              <ul>
                <li><a href="https://www.ugc.ac.in/" target="_blank" rel="noopener noreferrer">UGC</a></li>
                <li><a href="https://www.naac.gov.in/" target="_blank" rel="noopener noreferrer">NAAC</a></li>
                <li><a href="https://www.rusa.org.in/" target="_blank" rel="noopener noreferrer">RUSA</a></li>
                <li><a href="https://nad.gov.in/" target="_blank" rel="noopener noreferrer">NAD</a></li>
              </ul>
            </div>
            
            <div className="links-section">
              <h4>DIGITAL INITIATIVES</h4>
              <ul>
                <li><a href="https://swayam.gov.in/" target="_blank" rel="noopener noreferrer">SWAYAM</a></li>
                <li><a href="https://swayamprabha.gov.in/" target="_blank" rel="noopener noreferrer">SWAYAM Prabha</a></li>
                <li><a href="https://epgp.inflibnet.ac.in/" target="_blank" rel="noopener noreferrer">E-PG Pathshala</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>Copyright © 2025 S.N.Sinha College. All Rights Reserved.</p>
          <p>Design & Developed By IT HUB SOLUTION</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;